/**
 * Scroll to in-page anchors after navigation (e.g. PDP “Learn more” → Shipping & Support sections).
 * Theme editor page pickers omit #fragments; anchors come from link_anchor + section_anchor_id.
 */
(function () {
  var CHUNK_IN = 'r3nu-chunk--in';

  function headerOffsetPx() {
    var css = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    var n = parseFloat(css);
    if (!isNaN(n) && n > 0) return n + 16;
    var wrap = document.querySelector('.header-wrapper, .section-header');
    return (wrap ? wrap.offsetHeight : 96) + 16;
  }

  /** Reveal intro chunks in target so layout height matches scroll position. */
  function forceRevealIntroChunks(root) {
    if (!root || !root.hasAttribute('data-r3nu-intro-reveal')) return;
    if (root.classList.contains('shipping-delivery')) {
      root
        .querySelectorAll(
          '.shipping-delivery__eyebrow, .shipping-delivery__heading, .shipping-delivery__subtext, .shipping-delivery__card'
        )
        .forEach(function (el) {
          el.classList.add(CHUNK_IN);
        });
    }
  }

  function scrollToId(id, behavior) {
    if (!id) return false;
    var el = document.getElementById(id);
    if (!el) return false;
    forceRevealIntroChunks(el);
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffsetPx();
    window.scrollTo({ top: Math.max(0, top), behavior: behavior || 'auto' });
    return true;
  }

  function scrollFromHash(behavior) {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    scrollToId(hash.slice(1), behavior);
  }

  function scheduleHashScroll(behavior) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollFromHash(behavior);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleHashScroll('auto');
    });
  } else {
    scheduleHashScroll('auto');
  }

  window.addEventListener('load', function () {
    if (window.location.hash) scrollFromHash('auto');
  });

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest('a[href*="#"]');
      if (!a || a.target === '_blank') return;
      /*
       * The PDP review summary owns its own click (r3nu-review-scroll.js) and
       * deliberately scrolls WITHOUT writing a #hash. Both handlers sit on
       * document, so stopPropagation there could not stop this one — bail out
       * here instead. Otherwise the pushState below left #r3nu-reviews in the
       * URL for good, and every later reload reopened at the reviews section.
       */
      if (a.closest('[data-r3nu-review-scroll]')) return;
      var url;
      try {
        url = new URL(a.href, window.location.href);
      } catch (err) {
        return;
      }
      if (!url.hash || url.hash.length < 2) return;
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      e.preventDefault();
      var id = url.hash.slice(1);
      history.pushState(null, '', url.hash);
      scrollToId(id, 'smooth');
    },
    false
  );
})();
